import React, { ComponentType } from "react";

import dynamic from "next/dynamic";
import { LoadingSummary } from "./LoadingSummary";

const DynamicQuoteSummary = dynamic<ComponentType>(
  import("./QuoteSummary").then(({ QuoteSummary }) => QuoteSummary),
  {
    loading: () => <LoadingSummary />,
    ssr: false
  }
);

export { DynamicQuoteSummary };
